import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

export interface DocumentDetailsResponse {
  id: number;
  name: string;
  field_food_mandrian_title: string;
  field_food_malay_title: string;
  field_sequence_number: number;
  published: boolean;
  created_at: string;
  updated_at: string;
}

// Edit API call
const fetchOutletDetails = async (id: string): Promise<DocumentDetailsResponse | null> => {
  if (!id) return null;

  const response = await eramanCMSApi.get(`/api/food-beverage-types/all-fields/${id}`);

  const categoryData = response?.data?.[0];
  if (!categoryData) {
    throw new Error("Category not found");
  }

  return categoryData;
};

const useCategoryDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["categoryDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchOutletDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCategoryDocumentDetails };
